import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import {Helmet} from "react-helmet";
import { Image } from 'react-bootstrap'
import './app.scss';

function Epilogue() {

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      ReactGA.initialize('G-P248LQSJST');
    }
  }, []);

  const gaTrack = (category, action) => {
    if (process.env.NODE_ENV === 'production') {
        ReactGA.event({ category, action })
    }
  }

  return (
    <>
      <Helmet>
        <title>Epilogue &#124; It Makes Sense to Believe</title>
      </Helmet>

      <div className="book-body" >

        <div className="book-section0">
          <div className="book-section1 book-the-book">Epilogue</div>
          <div className="book-section2">
            Stay tuned ...
          </div>
          <div id="" className="book-section2b" >
            not written yet, but coming soon!
          </div>
          <div className="book-description">
            </div>
          <div className="book-section2"></div>
          <div className="book-description">
          </div>
        </div>



        <div className="book-section0">
          <div className="book-section1 contact-info">Contact Information</div>
          <div className="book-description">
            Please contact me at:
            <br className="show-hide" /> <a href="mailto: DeaconJohnBeagan@gmail.com">DeaconJohnBeagan@gmail.com</a>
            <br className="show-hide" /> if you have any questions or feedback.
            <br />God bless!
            <div className="signature">
              Deacon John Beagan
            </div>
            <div className="serving">
              Serving Sacred Heart &amp; Saint Patrick parishes in Watertown, MA
            </div>
            <div className="serving">
              Archdiocese of Boston
            </div>
          </div>
        </div>

      </div>
    </>
  );
}

export default Epilogue;
